export default __webpack_public_path__ + "static/media/worldfull.4fd7f136.svg";